const logoutUser = async () => {
  delete localStorage.accessToken;
  delete localStorage.userHeadquarterList;
  delete localStorage.selectedUserHeadquarter;
  delete localStorage.user;
  delete localStorage.____________________;
};

export default logoutUser;
